export const BusinessEventPage = () => <p>BusinessEventPage</p>;
